/**
 * http://confluence.mockuai.com/display/wdzgxcx/module_property%23title
 */
let config = [{
        "name": "App跳转",
        "type": "module-name"
    },
    {
        "key": "link_data",
        "name": "链接",
        "type": "jump-app"
    }
];
export default config;